module.exports = __webpack_public_path__ + "img/ylBg1.c45ed7df.png";